import React from 'react';
import styles from './AboutThisEventEmbedded.module.scss';
import classNames from 'classnames';

export type AboutThisEventEmbeddedProps = {
  visible?: boolean;
  children: React.ReactNode;
};

export const AboutThisEventEmbedded: React.FC<AboutThisEventEmbeddedProps> = React.memo(({ visible, children }) => {
  const containerClassName = classNames(styles.container, {
    [styles.hidden]: !visible,
  });

  return <div className={containerClassName}>{children}</div>;
});

AboutThisEventEmbedded.displayName = 'AboutThisEventEmbedded';
